// 首页 SdseeDoctor
export const navList = "/home/nav_list";
export const videoList = "/home/video_list"
export const adH5 = "/home/ad_h5"

// 导航 SdSeeNav
export const navList2 = "/nav/nav_list";

// 科室 SdSeeGroup OfficeKinds
export const channelList = "/home/channel_list";

// 搜索 SdSearch
export const searchDoctor = "/search/search_doctor";
export const searchVideo = "/search/search_video";
export const searchGroupList = '/search/group_list';
export const searchAll = "/search/search_all";
export const searchKeyWord = '/search/search_key_word';
export const searchClearKeyWord = '/search/clear_search_key_word';

// 专题 SdGroupDetail
export const shareAccount = "/user/share_account";
export const addViewHistory = "/center/add_view_history";
export const subjectTj = "/home/subject_tj";
export const creatItemOrder = "/order/create_item_order";
export const playRecord = "/home/play_record";
export const videoDetail = "/home/video_detail";
export const relatedDisease = "/home/related_diseases";
export const groupComment = "/home/group_comment"
export const groupCommetAdd = "/home/group_comment_add";
export const groupCommetDelete = "/home/group_comment_delete";
export const videoCollectAdd = "/home/video_collect_add";
export const videoCollectDelete = "/home/video_collect_delete";
export const videoCollect = "/home/video_collect";

// 图文 SdRichTxt
export const subject = "/home/subject";
// 重复部分尚未纪录

// 小知识点 SdDouyin
export const otherGroup = "/home/other_group";
export const douyinDetail = "/home/douyin_detail";
export const selectOrderStatus = "/order/select_order_status";
export const douyinList = "/home/douyin_list";
export const videoCommentList = "/home/video_comment_list";
export const recommendDoctorWx = "/home/recommend_doctor_wx";
export const videoCommentAdd = "/home/video_comment_add";
export const videoCommentDelete = "/home/video_comment_delete";
// /user/share_account 重复部分
// /order/create_item_order
// /order/create_item_order
// /home/play_record
// /home/video_detail
// /home/related_diseases
// /center/add_view_history
// /home/video_collect

/* 由于export太麻烦了，以下改用export default */
export default {
  // 问诊 SdAskDoctor
  doctorList: "/consult/doctor_list",
  hotDepartment: "/home/hot_department",
  departmentList: "/nav/department_list",
  navArea: "/nav/area",
  // 医生信息 SdDoctorMsg
  addCollectDoctor: "/collect/add-collect-doctor",
  doctorCollectCheck: "/center/doctor_collect_check",
  doctorCollectAdd: "/center/doctor_collect_add",
  deleteCollectDoctor: "/collect/delete-collect-doctor",
  doctorDetail: "/consult/doctor_detail",
  relatedDisease: "/home/related_diseases",
  // 咨询 SdInquiry
  selectOrderStatus: "/order/select_order_status",
  createWzOrder: "/order/create_wz_order",
  healthRecordsList: "/center/health_records_list",
  createPaidProblem: "/consult/create_paid_problem",
  createOrientedProblem: "/consult/create_oriented_problem",
  orderInfoRepay: "/order/order_info_repay",
  createPaidProblemSecond: "/consult/create_paid_problem_second",
  createOrientedProblemSecond: "/consult/create_oriented_problem_second",
  updateDoctor : "/consult/updateDoctor",
  // 登录 SdLogin
  siteLogin: "/site/login",
  sendSms: "/common/send_sms",
  // 注册 SdRegister
  singUp: "/site/signup",
  findPassword: "/site/find_password",
  // 我的 SdUserInfo
  centerTj: "/center/center_tj",
  logout: "/site/logout",
  getUserInfo: "/user/get_user_info",
  wdxx: "/user/wdxx",
  signupLogin: "/site/signup_login",
  bindwx: "/site/bindwx",
  loginwx: "/site/loginwx",
  editinfo: "/site/editinfo",
  uploadavatar: "/site/uploadavatar",
  // 消息中心
  getnews: "/site/getnews",
  readnews: "/site/readnews",
  deletenews: "/site/deletenews",
  // 观看历史 SdVideoHistory
  viewHistory: "/center/view_history",
  deleteViewHistory: "/center/delete_view_history",
  // 收藏 SdVideoCollect
  collectVideo: "/center/collect_video",
  deleteCollect: "/center/delete_collect_video",
  // 档案 SdHealthFile
  deleteHealth: "/center/delete_health_records",
  healthRecords: "/center/health_records_list",
  updateHealthRecords: "/center/update_health_records",
  saveHealthRecords: "/center/save_health_records",
  addHealthRecords: "/center/add_health_records",
  // 订单 SdAskOrder
  orderList: "/order/order_list",
  orderDelete: "/order/order_delete",
  orderClose: "/order/order_close",
  createOrder: "/order/create_order",
  createPaidProblem: "/consult/create_paid_problem_second",
  createOrientedProblem: "/consult/create_oriented_problem_second",
  // 已购视频 hasBuyHistory
  itemPayList: "/center/item_pay_list",
  // 我的医生 SdLikeDoctor
  collectDoctorList: "/collect/collect-doctor-list",
  createOrder: "/order/create_order?order_amount",
  // deleteCollectDoctor
  // 其他
  // App.vue
  onlineTime: "/user/zxrj",
  // 推荐医生
  doctorCheck: "/addoctor/check_info",
  submitDoctor: "/addoctor/submit_info",
  cheakClintid: "/addoctor/check_clintid",
  diseaseList: "/addoctor/list_disease",
  chooseDisease: "/addoctor/choose_disease",
  createProtocol: "/addoctor/create_authorization",
  agreeProtocol: "/addoctor/authorize",
  uploadPic: "/addoctor/attachment_upload",
  // 挂号
  goRegist: "/registration/getmttoken",
  rgsStatistic: "/registration/statisticsusers",
  uploadavatar: "/site/uploadavatar",
  // 保险统计
  rgsStsnce: "/registration/statisticsinsurance",
}



// WEBPACK FOOTER //
// ./src/api/index.js